import { Flex } from 'components/flex';
import { capitalize } from 'utils/string';
import { Dialog } from 'components/dialog';
import { formatPrice, getCartAmounts } from 'utils/helpers';
import { DeleteButtonWithRef } from 'components/specified-buttons';

import * as Styles from './styles';
import { Result, TotalCartProps } from './types';

export const TotalCart = ({
  tip,
  data,
  balance,
  children,
  onRemoveTip,
  shippingPrice,
  paymentMethods,
  companyProcessingFees,
}: TotalCartProps) => {
  const { tax, saleTotal, totalAmount, processingFees } = getCartAmounts({
    tip,
    data,
    shippingPrice,
    paymentMethods,
    companyProcessingFees,
  });

  const getTotalCardData = () => {
    const result: Result[] = [
      { title: 'Sub Total', value: totalAmount },
      { value: tax, title: `Tax (${data?.event?.tax ?? 0}%)` },
    ];

    if (typeof tip === 'number') {
      result.push({
        value: tip,
        title: 'Tip',
        subtitle: onRemoveTip ? (
          <Dialog
            title="Delete tip"
            onConfirm={onRemoveTip}
            trigger={<DeleteButtonWithRef />}
            text={
              <>
                You are about to delete tip. Are you sure you want to do this?
              </>
            }
          />
        ) : undefined,
      });
    }

    result.push({
      value: +processingFees,
      title: `Processing Fees (${companyProcessingFees}%)`,
    });

    if (Number(shippingPrice) > 0) {
      result.push({
        title: 'Shipping',
        value: shippingPrice,
      });
    }

    result.push({ value: saleTotal, title: 'Sale Total' });

    if (typeof balance === 'number') {
      result.push({ value: balance, title: 'Balance Due' });
    }

    return result;
  };

  return (
    <Styles.TotalCard>
      {getTotalCardData().map(({ title, value, subtitle }) => (
        <Flex gap={8} key={`${title}-${value}`} justifyContent="space-between">
          <Flex gap={8}>
            <Styles.Title>{title}</Styles.Title>
            {subtitle}
          </Flex>
          <Styles.Title>{formatPrice(value, '$0.00')}</Styles.Title>
        </Flex>
      ))}
      {children && (
        <>
          <Styles.Divider />
          {children}
          {paymentMethods?.map((value) => (
            <Flex
              justifyContent="space-between"
              key={`${value.type}-${value.amount}`}
            >
              <Styles.Title>{capitalize(value.type)}</Styles.Title>
              <Styles.Title>{formatPrice(value.amount)}</Styles.Title>
            </Flex>
          ))}
        </>
      )}
    </Styles.TotalCard>
  );
};
